import { SiteMaterialAutocomplete, TradeCompanyAutocomplete, useFormContext } from 'form';
import type { ComponentProps } from 'react';
import { Button, Stack } from 'ui';

type Props = {
  slotProps?: {
    tradeCompany?: ComponentProps<typeof TradeCompanyAutocomplete>;
    siteMaterial?: ComponentProps<typeof SiteMaterialAutocomplete>;
    siteMaterialAction?: ComponentProps<typeof Button>;
  };
};
export const TradeCompanySiteMaterialPicker = ({ slotProps }: Props) => {
  const { watch } = useFormContext();
  const tradeCompanyId = watch('trade_company');
  return (
    <>
      <TradeCompanyAutocomplete name="trade_company" label="Company" required {...slotProps?.tradeCompany} />

      <Stack direction="column" alignItems="flex-end" justifyContent="center" width="100%">
        <Button
          variant="text"
          component="a"
          fullWidth={false}
          target="_blank"
          href={`/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/new`}
          aria-label="Add new material"
          disabled={!tradeCompanyId}
          data-testid="site-material-action"
          {...slotProps?.siteMaterialAction}
        >
          Add new material
        </Button>
        <SiteMaterialAutocomplete
          name="trade_company_site_material"
          label="Site Material"
          disabled={!tradeCompanyId}
          tradeCompanyId={tradeCompanyId}
          required
          fullWidth
          disablePortal={false}
          data-testid="site-material-autocomplete"
          {...slotProps?.siteMaterial}
        />
      </Stack>
    </>
  );
};
